module.exports = __webpack_public_path__ + "static/media/pensioner-2.9e630514.png";